import React, { useEffect, useState } from "react";
import axios from "axios";
import { Star, Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials({ t, lang }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/testimonials`)
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  return (
    <section id="reviews" className="bg-white border-b-2 border-black" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-6">
            <div className="text-xs font-bold tracking-[0.22em] text-[#E11D2E]">{t.testimonials.eyebrow}</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1]">
              {t.testimonials.title}
            </h2>
          </div>
          <div className="md:col-span-6 flex md:justify-end items-end gap-6">
            <div className="flex items-center gap-2">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star key={i} size={22} fill="#E11D2E" className="text-[#E11D2E]" strokeWidth={0} />
              ))}
              <span className="font-display text-2xl ml-2">4.9</span>
              <span className="text-sm text-zinc-500">/ 5</span>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((r, i) => (
            <div
              key={r.id}
              className="relative bg-white border-2 border-black p-6 md:p-7 brutal-shadow"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={28} className="text-[#E11D2E]" />
              <div className="flex gap-1 mt-3">
                {Array.from({ length: r.rating }).map((_, k) => (
                  <Star key={k} size={16} fill="#E11D2E" className="text-[#E11D2E]" strokeWidth={0} />
                ))}
              </div>
              <p className="mt-4 text-[15px] leading-relaxed text-zinc-800">
                “{lang === "en" ? r.text_en : r.text_no}”
              </p>
              <div className="mt-6 pt-4 border-t border-zinc-200 flex items-center justify-between">
                <div>
                  <div className="font-display text-lg leading-none">{r.name}</div>
                  <div className="text-xs text-zinc-500 mt-1">{r.city}</div>
                </div>
                <div className="text-[10px] font-bold tracking-[0.2em] text-zinc-400">
                  VERIFISERT
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
